import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { MAINTENANCE_CONFIG, isFeatureAllowed, isCompleteMaintenance } from './config/maintenance';
import { isServicesPageEnabled } from './config/services';

// Components
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import DoctorSection from './components/DoctorSection';
import Services from './components/Services';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Login from './components/Login';
import Blog from './components/Blog';
import ArticleDetail from './components/ArticleDetail';
import AdminArticles from './components/AdminArticles';
import MaintenanceNotice from './components/MaintenanceNotice';
import MaintenancePage from './components/MaintenancePage';
import BabyMovementTracker from './components/BabyMovementTracker';
import ContractionTracker from './components/ContractionTracker';
import ProtectedRoute from './components/ProtectedRoute';

const HomePage = () => (
  <>
    <Hero />
    <About />
    <DoctorSection />
    {(isFeatureAllowed('services') && isServicesPageEnabled()) ? <Services /> : null}
    {isFeatureAllowed('contact') ? <Contact /> : null}
  </>
);

// Component to handle scroll restoration
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Only scroll to top for route changes, not hash changes
    if (!pathname.includes('#')) {
      window.scrollTo(0, 0);
    }
  }, [pathname]);

  return null;
};

function App() {
  // Check for complete maintenance mode - show only maintenance page
  if (isCompleteMaintenance()) {
    return <MaintenancePage />;
  }

  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <ScrollToTop />
          <Header />
          
          <Routes>
            {/* Home Page */}
            <Route path="/" element={<HomePage />} />
            
            {/* Authentication - Show maintenance notice if disabled */}
            <Route 
              path="/login" 
              element={isFeatureAllowed('login') ? <Login /> : <MaintenanceNotice />} 
            />
            
            {/* Blog Routes - Show maintenance notice if disabled */}
            <Route 
              path="/blog" 
              element={isFeatureAllowed('blog') ? <Blog /> : <MaintenanceNotice />} 
            />
            <Route 
              path="/blog/:id" 
              element={isFeatureAllowed('blog') ? <ArticleDetail /> : <MaintenanceNotice />} 
            />
            
            {/* Admin Routes - Show maintenance notice if disabled */}
            <Route 
              path="/admin/articles" 
              element={isFeatureAllowed('admin') ? <AdminArticles /> : <MaintenanceNotice />} 
            />
            
            {/* Baby Movement Tracker - Special User Only */}
            <Route 
              path="/baby-tracker" 
              element={
                <ProtectedRoute requireSpecialUser={true}>
                  <BabyMovementTracker />
                </ProtectedRoute>
              } 
            />

            {/* Contraction Tracker - Special User Only */}
            <Route 
              path="/contraction-tracker" 
              element={
                <ProtectedRoute requireSpecialUser={true}>
                  <ContractionTracker />
                </ProtectedRoute>
              } 
            />
          </Routes>
          
          <Footer />
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
